<template>
  <div class="report-details-header">
    <div class="report-details-header__content">
      <h2 class="report-details-header__title">
        {{ title }}
      </h2>

      <div class="report-details-header__print_block" data-html2canvas-ignore>
        <a-button
            class="report-details-header__print primary-button"
            @click="handlePrint"
            :loading="isPrinting"
        >
          <template #icon>
            <DownloadOutlined />
          </template>
          Печать
        </a-button>
      </div>
    </div>

    <div class="report-details-header__tags">
      <a-tag v-if="reportDetails.groupName">
        {{ reportDetails.groupName }}
      </a-tag>

      <a-tag v-if="reportDetails.filterName">
        {{ reportDetails.filterName }}
      </a-tag>

      <a-tag v-if="reportDetails.employeeCount">
        {{ reportDetails.employeeCount }}
      </a-tag>

      <a-tag v-if="reportDetails.dateString">
        {{ reportDetails.dateString }}
      </a-tag>
    </div>

    <div class="report-detail-mobile__print" data-html2canvas-ignore>
      <a-button
          class="report-details-header__print primary-button"
          @click="handlePrint"
          :loading="isPrinting"
      >
        Печать
      </a-button>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import {DownloadOutlined} from "@ant-design/icons-vue";
import html2pdf from "html2pdf.js";
import {ref} from "@vue/runtime-core";

export default {
  name: 'ReportDetailsHeader',
  components: {DownloadOutlined},
  props: {
    title: {
      type: String,
      default: '',
    },
    reportType: {
      type: String,
      default: '',
    }
  },
  setup(props) {
    const store = useStore();
    const isPrinting = ref(false);

    const reportDetails = computed(() => {
      return store.state.analytics.currentReportDetails ?? {
        groupName: null,
        filterName: null,
        employeeCount: null,
        dateString: null,
      }
    });

    const handlePrint = () => {
      isPrinting.value = true;

      prepareBeforePrint();

      html2pdf(document.getElementById("print_element"), {
        autoPaging: 'text',
        margin: [12, 8, 15, 8],
        filename: "analytics_base" + Date.now() + ".pdf",
        html2canvas: {
          dpi: 192,
          scale: 4,
          windowWidth: 1100,
        },
        pagebreak: {
          mode: ['css', 'legacy'],
          before: ['.pdf-page-break'],
          avoid: ['.pdf-avoid-break'],
        },
      }).then(() => {
        prepareAfterPrint();
        isPrinting.value = false;
      });
    }

    const prepareBeforePrint = () => {

    }

    const prepareAfterPrint = () => {

    }

    return {
      reportDetails,
      handlePrint,
      isPrinting
    }
  },
}
</script>

<style scoped lang="scss">
.report-details-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-bottom: 20px;
}

.report-details-header__content {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .report-details-header__print_block {
    @media (max-width: $mobile-breakpoint) {
      display: none;
    }
  }
}

.report-detail-mobile__print {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    display: block;
    width: 100%;

    button {
      width: 100%;
    }
  }
}

.report-details-header__title {
  margin: 0 !important;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}

.report-details-header__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.report-details-header__tags :deep(.ant-tag) {
  margin: 0;
  padding: 4px 8px;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.02);
  font-size: 12px;
  line-height: 110%;
}

.report-details-header__print {
  flex-shrink: 0;
}

@media (max-width: $mobile-breakpoint) {
  .report-details-header {
    flex-direction: column;
  }

  .report-details-header__print {
    align-self: flex-start;
  }
}
</style>
